module.exports = __webpack_public_path__ + "static/operation_casino-b30696d87da845ac662f4883ae98e6ca.mp3";